import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import RCLOfferNotification from './RCLOfferNotification';

const RCLOfferNotificationSection  = ({loanOffers = []}) => {
  if (loanOffers.length === 0) return null;

  const sortedLoanOffers = loanOffers.sort((dateA, dateB) => {
    return moment(dateB.created_at) - moment(dateA.created_at);
  });

  function renderNotifications() {
    return sortedLoanOffers.map((loanOffer, _index) => {
      return (
        <RCLOfferNotification
          key={loanOffer.id}
          amount={loanOffer.custom_fields.principal_amount}
        />
      );
    });
  }

  return renderNotifications();
}

RCLOfferNotificationSection.propTypes = {
  loanOffers: PropTypes.array.isRequired,
}

export default RCLOfferNotificationSection;



// WEBPACK FOOTER //
// ./src/features/home/components/RCLOfferNotificationSection.js